<aside class="maintenance-panel" aria-label="Prochaines interventions">
  <header class="maintenance-agenda-header">
    <h2>
      Prochaines interventions
      <span class="maintenance-agenda-count">({{ prochaines().length }})</span>
    </h2>
  </header>
  <div class="maintenance-agenda-list" [attr.aria-busy]="chargementInterventions()">
    @if (chargementInterventions()) {
      <p class="maintenance-feedback" role="status">Chargement des interventions...</p>
    } @else if (erreurInterventions()) {
      <p class="maintenance-feedback maintenance-feedback-error" role="alert">
        {{ erreurInterventions() }}
      </p>
    }
    @for (group of upcomingGroups(); track group.date) {
      <section class="maintenance-agenda-group">
        <h3>{{ group.label }}</h3>
        <div class="maintenance-agenda-items">
          @for (item of group.items; track trackIntervention($index, item)) {
            <article class="maintenance-agenda-card">
              @if (item.installationName || !item.ticketId) {
                <header class="intervention-card-header">
                  @if (lienTicket(item); as lien) {
                    <a
                      class="intervention-installation"
                      [routerLink]="lien"
                      [title]="installationLabel(item)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">home</span>
                      <span>{{ installationLabel(item) }}</span>
                    </a>
                  } @else {
                    <span class="intervention-installation" [title]="installationLabel(item)">
                      <span class="material-symbols-outlined" aria-hidden="true">home</span>
                      <span>{{ installationLabel(item) }}</span>
                    </span>
                  }
                </header>
              }
              <div class="intervention-card-planning">
                <div class="intervention-person">
                  <span class="intervention-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">person</span>
                  </span>
                  <strong>{{ item.site }}</strong>
                </div>
                <div class="intervention-consultation">
                  <div class="intervention-date">
                    <span class="material-symbols-outlined" aria-hidden="true">calendar_month</span>
                    <div>
                      <time [attr.datetime]="item.startsAt">{{
                        formatDate(item.startsAt, true)
                      }}</time>
                      <span class="intervention-time">{{ formatTimeRange(item) }}</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="intervention-icon intervention-open"
                    [attr.aria-label]="'Consulter l’intervention : ' + installationLabel(item)"
                    title="Consulter l’intervention"
                    (click)="ouvrirInterventionModal(item, $event)"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">construction</span>
                  </button>
                </div>
              </div>
              <section class="intervention-instructions">
                <h4>{{ item.nature === 'bon' ? 'Compte rendu' : 'À effectuer' }}</h4>
                <p>{{ item.comment || 'Aucune consigne renseignée.' }}</p>
              </section>
              @if (item.ticketId || item.ticketLibelle) {
                <footer class="intervention-card-ticket">
                  <div class="intervention-ticket-meta">
                    @if (lienTicket(item); as lien) {
                      <a class="intervention-ticket-reference" [routerLink]="lien">
                        #{{ item.ticketNumero ?? item.ticketId }}
                      </a>
                    }
                    <!-- Date d’ouverture du ticket, sans repli sur la création de l’intervention. -->
                    @if (
                      item.ticketDateCreation && formatDate(item.ticketDateCreation);
                      as dateCreation
                    ) {
                      <span class="intervention-ticket-created">
                        Créé le
                        <time [attr.datetime]="item.ticketDateCreation">{{ dateCreation }}</time>
                      </span>
                    }
                  </div>
                  @if (item.ticketLibelle) {
                    <p class="intervention-ticket-label" [innerHTML]="item.ticketLibelle"></p>
                  }
                </footer>
              }
            </article>
          }
        </div>
      </section>
    }
    @if (!chargementInterventions() && !erreurInterventions() && upcomingGroups().length === 0) {
      <p class="maintenance-feedback">
        Aucune intervention à venir{{ month() ? ' sur ce mois' : '' }}.
      </p>
    }
  </div>
</aside>
@if (interventionModalData(); as modal) {
  <app-intervention-modal [data]="modal" (fermer)="interventionOuverte.set(null)" />
}
